export default [
  [
    {
      id: 'name',
      type: 0,
      span: 12,
      offset: 0,
      props: {
        margin: '0 0 16px 0', padding: '8px 0', width: '100%', title: { text: 'ชื่อศูนย์บริการ *' },
      },
    }, {
      id: 'phoneNumber',
      type: 0,
      span: 12,
      offset: 0,
      props: {
        margin: '0 0 16px 0', padding: '8px 0', width: '100%', title: { text: 'เบอร์โทรศัพท์ *' },
      },
    }, {
      id: 'taxId',
      type: 0,
      span: 12,
      offset: 0,
      props: {
        margin: '0 0 16px 0', padding: '8px 0', width: '100%', title: { text: 'เลขผู้เสียภาษี' },
      },
    }, {
      id: 'address', // textArea
      label: 'ที่อยู่',
      span: 12,
      type: 6,
      props: { margin: '0 40px 0 0', width: '100%', title: { text: 'ที่อยู่' } },
    },
  ],
]
